import * as type from "./types";
import { createReducer } from "../../util/index";

const initialState = {};

const speedReducer = createReducer(initialState)({
  [type.VENDOR_LIST]: (state, action) => ({
    ...state,
    vendor: action.value,
  }),
  [type.GAME_LIST]: (state, action) => ({
    ...state,
    game: action.value,
  }),
  [type.SPEED_GAME_ACCESS]: (state, action) => ({
    ...state,
    rs: action.value,
  }),
});

export default speedReducer;
